import { FindClassificationTypesOutput } from '../../../services/modules/classificationTypes/classificationTypes.types';
import onlineClassificationTypesRepository from '../../../services/modules/classificationTypes/onlineClassificationTypes.repository';
import { offlineClassificationTypesRepository } from '../repositories/offlineClassificationTypes.repository';
import { createApiSauceResponse } from '../utils/createApiSauceResponse.util';
import { validateFindClassificationTypesOfflineParams } from './utils/onlineClassificationTypes.repository.offlineAdapters.utils';
import { notImplementedInOfflineError } from './utils/repository.offlineAdapters.utils';

const onlineClassificationTypesRepositoryOfflineAdapters = (): ReturnType<
  typeof onlineClassificationTypesRepository
> => {
  return {
    create: () => notImplementedInOfflineError('create'),
    delete: () => notImplementedInOfflineError('delete'),
    update: () => notImplementedInOfflineError('update'),
    find: () => notImplementedInOfflineError('find'),

    findClassificationTypes: async ({ entity, useAsFilter }) => {
      if (!validateFindClassificationTypesOfflineParams(entity, useAsFilter)) {
        return createApiSauceResponse<FindClassificationTypesOutput>({
          ok: false,
        });
      }

      const classificationTypes = await offlineClassificationTypesRepository.findAllUsedAsFilter();

      return createApiSauceResponse<FindClassificationTypesOutput>({
        ok: true,
        data: {
          data: classificationTypes,
          count: classificationTypes.length,
        },
      });
    },
  };
};

export default onlineClassificationTypesRepositoryOfflineAdapters;
